<template>
  <div class="cart__empty-footer">
    <a class="btn btn--primary" href="/collections/shop"><span>Shop all products</span></a>
    <ul class="cart__footer-icons">
      <li class="cart__footer-icon">
        <svg class="icon">
          <use href="#guarantee"></use>
        </svg>
        <span>100% happiness guarantee</span>
      </li>
      <li class="cart__footer-icon">
        <svg class="icon">
          <use href="#shipping-small"></use>
        </svg>
        <span>2-3 day shipping</span>
      </li>
    </ul>
  </div>
</template>

<script setup></script>